module.exports = __webpack_public_path__ + "img/icon_service.ce45ef09.svg";